export enum ClientDashBoardNavBarMenuItemId {
    HOMEPAGE = "Homepage",
    DOSSIERS = "Dossiers",
    DOCUMENTS = "Documents",
    LIBRARYDOCUMENTS = "LibraryDocuemnts",
    USERS = "Utilistaeurs",
}

export type Contact = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    profil: number;
};

export type postalAddress = {
    postalCode: string;
    city: string;
    street: string;
    additionalDetails: string;
};

export type User = {
    name: string;
    email: string;
    phoneNumber: string;
    password: string;
    confirmPassword?: string;
};

export type Establishment = {
    id?: number | null;
    siret: string;
    establishmentType: string;
    establishmentGroup: string;
    region?: string | null; 
    // synerpaNum: string;
    companyName: string;
    contactAddress: postalAddress;
    billingAddress: postalAddress;
    
    contacts: Contact[];
   
};

export * from "./Signup";
export * from "./Profil";
